import React,{useEffect,useRef,useState} from 'react'
import WebTemplate from '../Components/WebTemplate'
import { useGetAllSchoolsQuery} from '../Services/modules/school';
import { Link,useSearchParams  } from 'react-router-dom';
import sainikshala from "../assets/img/sainikshala.jpeg";
import { Config } from '../Config';

function ShatabdiGeneralMeritList() {
 
      
        return(
            <>
          

              <main id="main">
              <section id="clients" class="clients section-bg">
      <div class="container">

        <div class="row" data-aos="zoom-in">
    

        <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> शताब्दि शिष्यवृत्ती परीक्षा 4थी याद्या खालील प्रमाणे  2025-26</th>
         
        </tr>
      </thead>
      <tbody>
    
          <tr>
            <td>1</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/shatabdi/4_Shtabdi Rural Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

             
            सर्वसाधारण गुणवत्ता यादी 4थी ग्रामीण (2025-26 )
              </a>
              </td>           
          </tr>
      <tr>
            <td>2</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/shatabdi/4_Shtabdi Urban Prize Holders List.pdf`} 
            style={{color:'blue'}}
            target='_blank'>
     सर्वसाधारण गुणवत्ता यादी 4थी शहरी (2025-26)
              </a>
           
              </td>           
          </tr>
          <tr>
            <td>3</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/shatabdi/4_Shtabdi State Prize Holders List.pdf`}
            style={{color:'blue'}}
             target='_blank'>

               
        राज्यस्तरीय प्रथम ३ क्रमांक विद्यार्थी 4थी (2025-26)
              </a>
           
              </td>           
          </tr>
        
      </tbody>
    </table>

    <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> शताब्दि शिष्यवृत्ती परीक्षा ७वी याद्या खालील प्रमाणे  2025-26</th>
         
        </tr>
      </thead>
      <tbody>
    
          <tr>
            <td>1</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/shatabdi/7_Shtabdi Rural Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

             
            सर्वसाधारण गुणवत्ता यादी ७वी ग्रामीण (2025-26 )
              </a>
              </td>           
          </tr>
      <tr>
            <td>2</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/shatabdi/7_Shtabdi Urban Prize Holders List.pdf`} 
            style={{color:'blue'}}
            target='_blank'>
      सर्वसाधारण गुणवत्ता यादी ७वी शहरी (2025-26)
              </a>
           
              </td>           
          </tr>
          <tr>
            <td>3</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/shatabdi/7_Shtabdi State Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

      राज्यस्तरीय प्रथम ३ क्रमांक विद्यार्थी ७वी (2025-26)
              </a>
           
              </td>           
          </tr>
        
      </tbody>
    </table>
   

        </div>

      </div>
    </section>
 

</main>
            </>
        )
    

}

export default ShatabdiGeneralMeritList